import Avatar from '@/assets/icons/user-01.svg?react';
import DotsGrid from '@/assets/icons/dots-grid.svg?react';
import Conversations from '@/assets/icons/message-chat-square.svg?react';
import Surveys from '@/assets/icons/surveys-icon.svg?react';
import Maintenances from '@/assets/icons/maintances.svg?react';
import Documents from '@/assets/icons/file-06.svg?react';
import Power from '@/assets/icons/power-01.svg?react';
import Company from '@/assets/icons/company.svg?react';

export const navigationData = [
  {
    label: 'Profile',
    IconComponent: Avatar,
  },
  {
    label: 'Dashboard',
    IconComponent: DotsGrid,
  },
  {
    label: 'Conversations',
    IconComponent: Conversations,
  },
  {
    label: 'Surveys',
    IconComponent: Surveys,
  },
  {
    label: 'Work Orders',
    IconComponent: Maintenances,
  },
  {
    label: 'Documents',
    IconComponent: Documents,
  },
  {
    label: 'Company',
    IconComponent: Company,
  },
  {
    label: 'Logout',
    IconComponent: Power,
  },
];
